import { useInfiniteQuery } from 'react-query'
import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'
import {
  DOCUMENTS_QUERY_KEY,
  LIST_QUERY_KEY,
  SEARCH_TABLE_QUERY_KEY,
} from '@dc-shared-web/hooks/api/queryKeys'
import {
  fetchDocumentSearchResults,
  GetSearchResultQueryParams,
} from '@dc-shared-web/hooks/api/document/fetchDocumentSearchResults'

export const useGetSearchTableDocuments = (
  params: Omit<GetSearchResultQueryParams, 'offset'>
) => {
  const apiClient = useAxiosContext()

  return useInfiniteQuery({
    queryKey: [
      DOCUMENTS_QUERY_KEY,
      LIST_QUERY_KEY,
      SEARCH_TABLE_QUERY_KEY,
      params,
    ],
    queryFn: ({ pageParam }) => {
      return fetchDocumentSearchResults(apiClient, {
        ...params,
        offset: pageParam ?? 0,
      })
    },
    getNextPageParam: (lastPage, pages) => {
      return lastPage.length > 0
        ? pages.reduce((prev, page) => prev + page.length, 0)
        : undefined
    },
  })
}
